<!-- historical game from admin -->
<template>
  <div
    v-touch:swipe.prevent="preventDesktop(swipe)"
    class="slide sidearm-mm-game-recap relative"
  >
    <div
      class="sidearm-mm-game-recap__container relative h-100 text-white"
      :class="
        'swipe_direction_' + swipe_direction + ' swipe_step_' + swipe_step
      "
    >
      <div
        class="sidearm-mm-game-recap__background absolute flex flex-column h-100 w-100 flex-align-stretch flex-justify-start"
      >
        <div
          v-if="game.story && game.story.image"
          class="sidearm-mm-game-recap__background-image-container"
        >
          <div
            class="sidearm-mm-game-recap__background-image"
            :style="{
              backgroundImage:
                game.story && game.story.image
                  ? `url(${$root.absolutize_cdn(game.story.image.url)})`
                  : 'none'
            }"
          ></div>
        </div>
        <div
          class="sidearm-mm-game-recap__background-linescore text-black overflow-hidden"
        >
          <div
            v-if="line_scores"
            class="bg-white sidearm-mm-game-recap__linescore"
          >
            <table
              class="sidearm-mm-game-recap__linescore-table text-center type-paragraph-small w-100"
              cellspacing="0"
            >
              <caption class="hide">
                Score by Periods
              </caption>
              <tbody>
                <tr>
                  <th scope="row" class="text-normal">
                    <div
                      :class="{
                        'sidearm-mm-game-recap__linescore-winner':
                          line_scores.game_winner !== 'H'
                      }"
                      class="flex flex-align-center"
                    >
                      <img
                        :src="
                          `${
                            line_scores.period_away_score[
                              line_scores.period_away_score.length - 1
                            ] === game.result.opponent_score
                              ? $root.absolutize_cdn(game.opponent.image.url)
                              : $root.school_logo()
                          }?width=36&height=36`
                        "
                        class="sidearm-mm-game-recap__linescore-logo pa-1"
                      />
                      <span
                        class="sidearm-mm-game-recap__linescore-team text-left"
                        >{{
                          line_scores.period_away_score[
                            line_scores.period_away_score.length - 1
                          ] === game.result.opponent_score
                            ? $root.shorten_name(game.opponent.title)
                            : $root.data.school.name
                        }}</span
                      >
                    </div>
                  </th>
                  <td
                    v-for="(score, index) in line_scores.period_away_score"
                    :key="index"
                    :class="{
                      'border-light-l text-bold':
                        index === line_scores.period_away_score.length - 1
                    }"
                    class="px-05"
                  >
                    {{ score }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="border-light-t text-normal ">
                    <div
                      :class="{
                        'sidearm-mm-game-recap__linescore-winner':
                          line_scores.game_winner === 'H'
                      }"
                      class="flex flex-align-center"
                    >
                      <img
                        :src="
                          `${
                            line_scores.period_away_score[
                              line_scores.period_away_score.length - 1
                            ] != game.result.opponent_score
                              ? $root.absolutize_cdn(game.opponent.image.url)
                              : $root.school_logo()
                          }?width=36&height=36`
                        "
                        class="sidearm-mm-game-recap__linescore-logo pa-1"
                      />
                      <span
                        class="sidearm-mm-game-recap__linescore-team text-left"
                        >{{
                          line_scores.period_away_score[
                            line_scores.period_away_score.length - 1
                          ] != game.result.opponent_score
                            ? this.$root.shorten_name(game.opponent.title)
                            : $root.data.school.name
                        }}</span
                      >
                    </div>
                  </th>
                  <td
                    v-for="(score, index) in line_scores.period_home_score"
                    :key="index"
                    :class="{
                      'border-light-l text-bold':
                        index === line_scores.period_home_score.length - 1
                    }"
                    class="px-05 border-light-t"
                  >
                    {{ score }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h3
          class="sidearm-mm-game-recap__game-index  type-heading-bracket-plain --light pl-4 pt-2 ma-0"
        >
          Game {{ index.toString().padStart(3, "0") }}
        </h3>
      </div>
      <transition :name="panel_transition">
        <div
          v-show="swipe_step === 0"
          class="sidearm-mm-game-recap__title sidearm-mm-game-recap__panel absolute h-100 w-100  px-4 flex flex-align-end flex-justify-start"
        >
          <h4
            class="type-hero mt-0 mb-9"
            :class="{
              '--long': this.$root.shorten_name(game.opponent.title).length > 13
            }"
          >
            {{ game.location_indicator === "A" ? "at" : "vs." }}
            {{ this.$root.shorten_name(game.opponent.title) }}
          </h4>
        </div>
      </transition>
      <transition :name="panel_transition">
        <div
          v-show="swipe_step === 1"
          class="sidearm-mm-game-recap__subtitle sidearm-mm-game-recap__panel absolute h-100 w-100 px-4 flex flex-align-center flex-justify-start"
        >
          <a
            v-if="game.story && game.story.url"
            :href="game.story.url"
            target="_blank"
            class="sidearm-mm-game-recap__story-link type-paragraph-large ma-0 text-decoration-none"
          >
            Recap: {{ game.story.headline }}
          </a>
        </div>
      </transition>
      <transition :name="panel_transition">
        <div
          v-show="swipe_step === 2"
          class="sidearm-mm-game-recap__ctas sidearm-mm-game-recap__panel absolute h-100 w-100 px-4 flex flex-column flex-align-start flex-justify-center"
        >
          <!-- TODO-KL there is not game story video atm, would have to do another join, could have them manually pick one though -->
          <div
            v-if="game.story && game.story.video"
            class="flex flex-align-center pb-2"
          >
            <modal-video :video="game.story.video">
              <button
                slot-scope="scope"
                type="button"
                @click="scope.open"
                class="sidearm-mm-play-btn"
                aria-label="Watch Highlight"
              >
                <icon>sf-play-minimal</icon>
              </button>
            </modal-video>
            <div class="type-paragraph mx-1">Related Video</div>
          </div>
          <a
            v-if="game.result.boxscore"
            :href="game.result.boxscore"
            target="_blank"
            class="sidearm-mm-btn --ghost"
            >Box Score</a
          >
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "SlideGameRecap",
  props: {
    // TODO-KL is this right?/round
    game: { type: Object, required: true },
    index: { type: Number, required: false }
  },

  components: {},

  data: () => ({
    swipe_step: 0,
    swipe_direction: "",
    panel_transition: "right"
  }),

  computed: {
    line_scores() {
      if (this.game && this.game.result.result_json) {
        try {
          return JSON.parse(this.game.result.result_json);
        } catch (e) {
          console.log("Failed to parse linescore json", e);
          return null;
        }
      }

      return null;
    },
    swipe_intervals() {
      let _intervals = 0;
      if (this.game && this.game.story) {
        _intervals++;
      }
      if (
        (this.game && this.game.result.boxscore) ||
        (this.game && this.game.story && this.game.story.video)
      ) {
        _intervals++;
      }
      return _intervals;
    }
  },
  methods: {
    swipe(direction) {
      if (direction === "left") {
        this.swipeLeft();
      }
      if (direction === "right") {
        this.swipeRight();
      }
      if (direction === "bottom") {
        this.swipeUp();
      }
      if (direction === "top") {
        this.swipeDown();
      }
    },
    swipeLeft() {
      if (this.swipe_step >= this.swipe_intervals) {
        if (this.index === this.$parent.section.games.length) {
          this.moveSectionDown();
        } else {
          this.moveSlideRight();
        }
      } else {
        this.panel_transition = "right";
        this.swipe_step++;
      }
    },
    swipeRight() {
      if (this.swipe_step === 0) {
        this.moveSlideLeft();
      } else {
        this.panel_transition = "left";
        this.swipe_step--;
      }
    },
    swipeDown() {
      this.moveSectionDown();
    },
    swipeUp() {
      this.moveSectionUp();
    }
  },
  mounted() {
    // TODO-KL check prop
    // debugger;
  }
};
</script>
<style lang="scss" scoped>
.sidearm-mm-game-recap {
  &__divider {
    top: calc(50% + #{$header-height/2});
    transform: translateY(-50%);
    z-index: 1;
    > span {
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }
    &--start {
      top: 50%;
      left: 0;
      padding-left: 36px;
      &::before {
        position: absolute;
        top: 50%;
        left: 0;
        width: 36px;
        height: 1px;
        content: "";
        background: $color-white;
      }
    }
    &--end {
      right: 0;
      &::before {
        width: calc(33.3333% - 1.5rem);
        height: 1px;
        position: absolute;
        top: 50%;
        left: 1.5rem;
        content: "";
        background: $color-white;
      }
      &::after {
        width: 100%;
        height: 1px;
        position: absolute;
        top: 50%;
        left: 33.3333%;
        content: "";
        background-color: $color-black;
      }
    }
  }
  &__top-background-element {
    top: $header-height;
    left: 0;
    height: calc((100% - #{$header-height}) * 0.375);
    z-index: 1;
  }
  &__bottom-background-element {
    bottom: 0;
    right: 50%;
    height: calc((100% - #{$header-height}) * 0.625);
    z-index: 1;
  }

  &__background {
    top: 0;
    left: 0;
  }
  &__background-image-container {
    @include flex-item(1 1 auto);
    position: relative;
    height: 100%;
  }
  &__background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: top center;
    background-size: cover;
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      background: rgba(0, 0, 0, 0.7);
    }
  }

  &__background-linescore {
    @include flex-item(0 0 auto);
    // height: 10.5rem;
    transition: height 0.4s;
  }

  &__game-index {
    top: $header-height-mobile;
    left: 0;
    position: absolute;
  }

  &__content {
    z-index: 2;
    padding-top: calc(#{$header-height} + #{grid_percent(60)});
    padding-bottom: #{grid_percent(120)};
  }
  &__linescore {
    padding: #{grid_percent(30)};
    @include flex-item(0 0 auto);
  }
  &__linescore-team {
  }
  &__linescore-winner {
    position: relative;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      width: $spacer/2;
      height: $spacer/2;
      border-radius: 50%;
      content: "";
      background: $color-success;
      transform: translateY(-50%);
    }
  }
  &__story-link {
    color: $color-white;
  }
  &__links {
    @include flex-item(0 0 auto);
    height: 50%;
  }
  .sidearm-mm-play-btn {
    @include play-btn(3.75rem);
  }
}

.sidearm-mm-game-recap__container {
  &.swipe_step_0 {
    .sidearm-mm-game-recap__background-linescore {
      height: 0;
    }
  }
}

.right-enter-active,
.right-leave-active {
  transition: all 0.5s ease;
}
.right-enter {
  transform: translateX(50%);
  opacity: 0;
}
.right-leave-to {
  transform: translateX(-50%);
  opacity: 0;
}

.left-enter-active,
.left-leave-active {
  transition: all 0.5s ease;
}
.left-enter {
  transform: translateX(-50%);
  opacity: 0;
}
.left-leave-to {
  transform: translateX(50%);
  opacity: 0;
}
</style>
